<template>
  <div>
    <el-form-item :label="labelText(zdItem.label)">
      <el-row>
        <el-col :span="7">
          <el-input 
            placeholder="请输入内容" 
            v-model="specification" 
            :disabled="getDisable() || getAuthShow()"
            :class="{ 'question-mark-highlight': hasQuestionMarkSpecification }"
          >
            <template slot="prepend">Specification</template>
          </el-input>
        </el-col>
        <el-col :span="7" :offset="1">
          <el-input 
            placeholder="请输入内容" 
            v-model="result"
            :class="{ 'question-mark-highlight': hasQuestionMarkResult }"
          >
            <template slot="prepend">Result</template>
            <template v-if="getShowUnit()">
              <template slot="append">cfu/g</template>
            </template>
          </el-input>
        </el-col>
        <el-col :span="7" :offset="1">
          <el-input 
            placeholder="请输入内容" 
            v-model="testMethod" 
            :disabled="getDisable() || getAuthShow()"
            :class="{ 'question-mark-highlight': hasQuestionMarkTestMethod }"
          >
            <template slot="prepend">Test Method</template>
          </el-input>
        </el-col>
      </el-row>
    </el-form-item>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import base from "@/common/base.js";

export default {
  name: "ZDThreeInput",
  props: {
    zdId: {
      type: String,
      required: true,
    },
    pageStatus: {
      type: String,
      default: "Add",
    },
  },
  computed: {
    ...mapGetters("zdInput", {
      zdGetComponentState: "getComponentState",
    }),
    
    zdComponentState() {
      return this.zdGetComponentState(this.zdId);
    },
    
    zdItem() {
      return this.zdComponentState || { value: {} };
    },
    
    labelText() {
      return (label) => {
        let key = "content." + label;
        key = key.toLowerCase().replaceAll(" ", "_");
        return this.$t(key);
      };
    },
    
    // 使用计算属性替代直接绑定
    specification: {
      get() {
        return this.zdItem.value?.specification || "";
      },
      set(value) {
        this.updateField("specification", value);
      }
    },
    
    result: {
      get() {
        // 确保返回值为字符串，以避免 .includes() 错误
        const value = this.zdItem.value?.result;
        return typeof value === 'string' ? value : String(value || "");
      },
      set(value) {
        this.updateField("result", value);
      }
    },
    
    testMethod: {
      get() {
        return this.zdItem.value?.test_method || "";
      },
      set(value) {
        this.updateField("test_method", value);
      }
    },
    hasQuestionMarkSpecification() {
      const spec = this.specification || "";
      return spec.includes('?') || spec.includes('？');
    },
    hasQuestionMarkResult() {
      const res = this.result || "";
      return res.includes('?') || res.includes('？');
    },
    hasQuestionMarkTestMethod() {
      const method = this.testMethod || "";
      return method.includes('?') || method.includes('？');
    }
  },
  created() {
    if(this.zdItem.label=='Total Plate Count'){
      // console.info("zdItem:", this.zdItem.value);
    }
    
    // 监听页面状态变化
    this.$EventBus.$on("pageStatusChange", this.handlePageStatusChange);
    this.$EventBus.$on("tabChanged", this.handleTabChanged);
  },
  
  beforeDestroy() {
    // 清理事件监听器
    this.$EventBus.$off("pageStatusChange", this.handlePageStatusChange);
    this.$EventBus.$off("tabChanged", this.handleTabChanged);
  },
  
  methods: {
    ...mapActions("zdInput", ["updateComponent"]),
    
    // 统一更新字段的方法
    updateField(field, value) {
      const newValue = {
        ...this.zdItem.value,
        [field]: value
      };
      
      this.updateComponent({
        id: this.zdId,
        field: "value",
        value: newValue
      });
    },
    getAuthShow(){
      return base.getAuthShow();
    },
    getShowUnit(){
      if(this.zdItem.label=='Total Plate Count' || this.zdItem.label=='Yeast And Mold'){
        return true;
      }
      return false;
    },
    
    getDisable() {
      const pageStatus = this.pageStatus;
      
      // 如果页面状态是Detail，所有字段都不可编辑
      if (pageStatus === "Detail") {
        return true;
      }
      
      // 如果页面状态是Edit，根据业务规则决定是否可编辑
      let type = this.$route.query.type;
      if (type === 'coa' && pageStatus === 'Edit') {
        return true;
      }
      
      // 返回字段本身的disabled配置
      return this.zdItem.disabled || false;
    },
    
    /**
     * 处理页面状态变化
     */
    handlePageStatusChange(pageStatus) {
      console.info("ZDThreeInput: Page status changed to", pageStatus, "for component", this.zdId);
      
      // 强制组件重新计算disabled状态
      this.$forceUpdate();
    },
    
    /**
     * 处理标签页变化
     */
    handleTabChanged(data) {
      console.info("ZDThreeInput: Tab changed to", data.tabName, "with status", data.pageStatus, "for component", this.zdId);
      
      // 强制组件重新计算disabled状态
      this.$forceUpdate();
    }
  }
};
</script>
<style src="./input-highlight.css" scoped>

</style>